module.exports = __webpack_public_path__ + "static/media/DownloadIcon.cf043e7f.svg";